import * as React from "react";
import { useStaticQuery, graphql } from 'gatsby';
import { getImage } from "gatsby-plugin-image";
import { GatsbyImage } from "gatsby-plugin-image";

const useImage = (relativePath, alt) => {
  const allImages = useStaticQuery(graphql`
  {
    allFile {
      nodes {
        relativePath
        childImageSharp {
          gatsbyImageData(
            placeholder: BLURRED
          )
        }
        publicURL
      }
    }
  }
  `);
  const image = allImages.allFile.nodes.find(i => i.relativePath === relativePath);
  if (image === undefined) {
    return <span>Fail to load image</span>;
  }
  if (relativePath.includes(".svg")) {
    return (
      <img src={image.publicURL} alt={alt} />
    )
  } else {
    const imageSrc = getImage(image.childImageSharp);
    return (
      <GatsbyImage image={imageSrc} alt={alt} />
    );
  }
};

export default useImage;
